import React from 'react';
import { Button } from 'semantic-ui-react';
import { FileQuestion, AlertOctagon } from 'lucide-react';
export function ErrorComponent({ title, subtitle, iconVariant, additionalContent, ctaButtonProps }) {
    return (React.createElement("div", { className: "flex flex-col items-center justify-center min-h-[60vh] px-4 py-8 text-center bg-gradient-to-br from-gray-50 to-white rounded-lg my-8 mx-auto max-w-4xl" },
        React.createElement("div", { className: "w-32 h-32 rounded-full flex items-center justify-center mb-8 shadow-lg relative", style: {
                background: 'linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-dark) 100%)',
                animation: 'float 3s ease-in-out infinite',
            } },
            iconVariant == 'file-question' && React.createElement(FileQuestion, { size: 64, className: "text-white", strokeWidth: 1.5, style: { filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' } }),
            iconVariant == 'error' && React.createElement(AlertOctagon, { size: 64, className: "text-white", strokeWidth: 1.5, style: { filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' } })),
        React.createElement(SecondaryText, { text: title }),
        React.createElement("p", { className: "text-xl mb-8 leading-relaxed max-w-2xl", style: { fontFamily: 'var(--font-family)', color: 'var(--text-light)' } }, subtitle),
        additionalContent && additionalContent,
        React.createElement(Button, { primary: true, href: ctaButtonProps.href, target: ctaButtonProps.target, rel: "noopener noreferrer", size: "big" }, ctaButtonProps.text),
        React.createElement("style", null, `
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        `)));
}
function SecondaryText({ text }) {
    return React.createElement("p", { className: "text-2xl mb-3 leading-relaxed max-w-3xl font-medium", style: { fontFamily: 'var(--font-family)', color: 'var(--primary-color)' } }, text);
}
